module.exports = __webpack_public_path__ + "static/img/correct.5a4046c0.svg";